enum CommonEnum {
  'cancel' = 'cancel',
  'name' = 'name',
  'price' = 'price',
  'action' = 'action',
  'bid' = 'bid',
  'ask' = 'ask',
  'order' = 'order',
  'most_popular' = 'most_popular',
  'lowest_ask' = 'lowest_ask',
  'collections' = 'collections',
  'start_selling' = 'start_selling',
  'most_watched' = 'most_watched',
  'popular_brands' = 'popular_brands',
  'new' = 'new',
  'latest_blog_posts' = 'latest_blog_posts',
  'latest_blog_posts_v2' = 'latest_blog_posts_v2',
  'all_articles' = 'all_articles',
  'product' = 'product',
  'get_started' = 'get_started',
  'how_it_works' = 'how_it_works',
  'view_more' = 'view_more',
  'personal_favorites' = 'personal_favorites',
  'investment' = 'investment',
  'annual_releases' = 'annual_releases',
  'occasion' = 'occasion',
  'buyer_guide' = 'buyer_guide',
  'seller_guide' = 'seller_guide',
  'authentication' = 'authentication',
  'portfolio_guide' = 'portfolio_guide',
  'shipping_guide' = 'shipping_guide',
  'bottle_condition' = 'bottle_condition',
  'bottles' = 'bottles',
  'help' = 'help',
  'jobs' = 'jobs',
  'congratulations' = 'congratulations',
  'email_verified' = 'email_verified',
  'email_verified_message' = 'email_verified_message',
  'status' = 'status',
  'has_bids' = 'has_bids',
  'has_asks' = 'has_asks',
  'brands' = 'brands',
  'countries' = 'countries',
  'topics' = 'topics',
  'about_spiritory' = 'about_spiritory',
  'become_seller' = 'become_seller',
  'type' = 'type',
  'category' = 'category',
  'country' = 'country',
  'citizenship' = 'citizenship',
  'go' = 'go',
  'products' = 'products',
  'filter' = 'filter',
  'show_more' = 'show_more',
  'results' = 'results',
  'search_something' = 'search_something',
  'error_loading' = 'error_loading',
  'loading' = 'loading',
  'please_wait' = 'please_wait',
  'condition_guide' = 'condition_guide',
  'share' = 'share',
  'asks' = 'asks',
  'bids' = 'bids',
  'orders' = 'orders',
  'dashboard' = 'dashboard',
  'hey_there' = 'hey_there',
  'close' = 'close',
  'activity' = 'activity',
  'units' = 'units',
  'something_went_wrong' = 'something_went_wrong',
  'trend' = 'trend',
  'suggest_a_bottle' = 'suggest_a_bottle',
  'amount' = 'amount',
  'purchase_date' = 'purchase_date',
  'add' = 'add',
  'search' = 'search',
  'value' = 'value',
  'other_spirits' = 'other_spirits',
  'language' = 'language',
  'statusOrder.authentication' = 'statusOrder.authentication',
  'statusOrder.payment' = 'statusOrder.payment',
  'statusOrder.shipping' = 'statusOrder.shipping',
  'statusOrder.payout' = 'statusOrder.payout',
  'statusOrder.completed' = 'statusOrder.completed',
  'confirm_now' = 'confirm_now',
  'received' = 'received',
  'pay_now' = 'pay_now',
  'selling' = 'selling',
  'sales' = 'sales',
  'authenticate' = 'authenticate',
  'ship_now' = 'ship_now',
  'retry_shipping' = 'retry_shipping',
  'shipping' = 'shipping',
  'tracking_number' = 'tracking_number',
  'save_tracking' = 'save_tracking',
  'authenticated' = 'authenticated',
  'shipping_label' = 'shipping_label',
  'address' = 'address',
  'city' = 'city',
  'enter_your_city' = 'enter_your_city',
  'country_code' = 'country_code',
  'zip_code' = 'zip_code',
  'portfolio' = 'portfolio',
  'delete_selected' = 'delete_selected',
  'hide' = 'hide',
  'select' = 'select',
  'deselect' = 'deselect',
  'delete' = 'delete',
  'all_categories' = 'all_categories',
  'current_value' = 'current_value',
  'highest_bid' = 'highest_bid',
  'profit_and_loss' = 'profit_and_loss',
  'wishlist' = 'wishlist',
  'start_buying' = 'start_buying',
  'start_exploring' = 'start_exploring',
  'last_viewed' = 'last_viewed',
  'submit' = 'submit',
  'format' = 'format',
  'release_date' = 'release_date',
  'external_link' = 'external_link',
  'notes' = 'notes',
  'add_image' = 'add_image',
  'brand' = 'brand',
  'photo_added' = 'photo_added',
  'add_photo' = 'add_photo',
  'or_drag_and_drop' = 'or_drag_and_drop',
  'filters' = 'filters',
  'date' = 'date',
  'all' = 'all',
  'last_24_hours' = 'last_24_hours',
  'last_3_days' = 'last_3_days',
  'last_week' = 'last_week',
  'last_month' = 'last_month',
  'last_year' = 'last_year',
  'custom' = 'custom',
  'categories' = 'categories',
  'period' = 'period',
  'apply' = 'apply',
  'information' = 'information',
  'new_bids' = 'new_bids',
  'new_asks' = 'new_asks',
  'new_matches' = 'new_matches',
  'expired' = 'expired',
  'notifications' = 'notifications',
  'saving' = 'saving',
  'yes' = 'yes',
  'no' = 'no',
  'first_name' = 'first_name',
  'second_name' = 'second_name',
  'enter_your_first_name' = 'enter_your_first_name',
  'last_name' = 'last_name',
  'enter_your_last_name' = 'enter_your_last_name',
  'email' = 'email',
  'enter_your_email' = 'enter_your_email',
  'enter_your_message' = 'enter_your_message',
  'contactUs' = 'contactUs',
  'fill_with_your_account_information' = 'fill_with_your_account_information',
  'phone_number' = 'phone_number',
  'enter_your_phone_number' = 'enter_your_phone_number',
  'date_of_birth' = 'date_of_birth',
  'enter_your_date_of_birth' = 'enter_your_date_of_birth',
  'english' = 'english',
  'german' = 'german',
  'french' = 'french',
  'italian' = 'italian',
  'select_country' = 'select_country',
  'postal_code' = 'postal_code',
  'enter_your_zip_postal_code' = 'enter_your_zip_postal_code',
  'save_changes' = 'save_changes',
  'error_loading_user' = 'error_loading_user',
  'password' = 'password',
  'request_password_change' = 'request_password_change',
  'delete_account' = 'delete_account',
  'are_you_sure_you_want_to_delete_your_account' = 'are_you_sure_you_want_to_delete_your_account',
  'error_deleting_account' = 'error_deleting_account',
  'deleting_account' = 'deleting_account',
  'account_deleted_successfully' = 'account_deleted_successfully',
  'enter_name_of_city' = 'enter_name_of_city',
  'street_and_house_number' = 'street_and_house_number',
  'enter_address' = 'enter_address',
  'active' = 'active',
  'inactive' = 'inactive',
  'edit' = 'edit',
  'remove' = 'remove',
  'iban' = 'iban',
  'save' = 'save',
  'austria' = 'austria',
  'belgium' = 'belgium',
  'bulgaria' = 'bulgaria',
  'croatia' = 'croatia',
  'cyprus' = 'cyprus',
  'czech_republic' = 'czech_republic',
  'denmark' = 'denmark',
  'estonia' = 'estonia',
  'finland' = 'finland',
  'france' = 'france',
  'germany' = 'germany',
  'greece' = 'greece',
  'hungary' = 'hungary',
  'ireland' = 'ireland',
  'italy' = 'italy',
  'latvia' = 'latvia',
  'lithuania' = 'lithuania',
  'luxembourg' = 'luxembourg',
  'malta' = 'malta',
  'netherlands' = 'netherlands',
  'poland' = 'poland',
  'portugal' = 'portugal',
  'romania' = 'romania',
  'slovakia' = 'slovakia',
  'spain' = 'spain',
  'sweden' = 'sweden',
  'united_kingdom' = 'united_kingdom',
  'an_unexpected_error_occurred' = 'an_unexpected_error_occurred',
  'try_again' = 'try_again',
  'email_address' = 'email_address',
  'message' = 'message',
  'failedToSendMessage' = 'failedToSendMessage',
  'messageSentSuccessfully' = 'messageSentSuccessfully',
  'SendingMessage' = 'SendingMessage',
  'minTenCharactersMessage' = 'minTenCharactersMessage',
  'emailInvalid' = 'emailInvalid',
  'captchaRequired' = 'captchaRequired',
  'messageRequired' = 'messageRequired',
  'nameRequired' = 'nameRequired',
  'emailRequired' = 'emailRequired',
  'message_help_placeholder' = 'message_help_placeholder',
  'uploading_images' = 'uploading_images',
  'uploading' = 'uploading',
  'required' = 'required',
  'payment' = 'payment',
  'munich' = 'munich',
  'confirm' = 'confirm',
  'payout_method' = 'payout_method',
  'please_add_payout_method' = 'please_add_payout_method',
  'has_error_user.text1' = 'has_error_user.text1',
  'has_error_user.text2' = 'has_error_user.text2',
  'has_error_user.text3' = 'has_error_user.text3',
  'change' = 'change',
  'view_all' = 'view_all',
  'you_got_the_status_buyer' = 'you_got_the_status_buyer',
  'you_got_the_status_buyer_subtitle' = 'you_got_the_status_buyer_subtitle',
  'become_a_buyer' = 'become_a_buyer',
  'become_a_buyer_subtitle' = 'become_a_buyer_subtitle',
  'spanish' = 'spanish',
  'whisky' = 'whisky',
  'wine' = 'wine',
  'rum' = 'rum',
  'gin' = 'gin',
  'your_buy_price' = 'your_buy_price',
  'processing_fee' = 'processing_fee',
  'enter_your_coupon_code' = 'enter_your_coupon_code',
  'coupon_value' = 'coupon_value',
  'removing_tax_id' = 'removing_tax_id',
  'account_number_deleted_successfully' = 'account_number_deleted_successfully',
  'removing_account_number' = 'removing_account_number',
  'removing_iban' = 'removing_iban',
  'please_enter_tax_id' = 'please_enter_tax_id',
  'updating_tax_id' = 'updating_tax_id',
  'tax_number_added_successfully' = 'tax_number_added_successfully',
  'tax_number_edited_successfully' = 'tax_number_edited_successfully',
  'tax_number_deleted_successfully' = 'tax_number_deleted_successfully',
  'professional_type_updated_successfully' = 'professional_type_updated_successfully',
  'updating_professional_type' = 'updating_professional_type',
  'adding_tax_id' = 'adding_tax_id',
  'updating_iban' = 'updating_iban',
  'iban_added_successfully' = 'iban_added_successfully',
  'iban_edited_successfully' = 'iban_edited_successfully',
  'iban_deleted_successfully' = 'iban_deleted_successfully',
  'adding_iban' = 'adding_iban',
  'included' = 'included',
  'shipping_costs_included' = 'shipping_costs_included',
  'will_be_calculated_later' = 'will_be_calculated_later',
  'shipping_calculated_later' = 'shipping_calculated_later',
  'no_wishlist' = 'no_wishlist',
  'no_wishlist_subtitle' = 'no_wishlist_subtitle',
  'view_product' = 'view_product',
  'details' = 'details',
  'price_of_bid' = 'price_of_bid',
  'are_you_sure_you_want_to_delete_this_bid' = 'are_you_sure_you_want_to_delete_this_bid',
  'edit_bid' = 'edit_bid',
  'edit_details' = 'edit_details',
  'extend_for_7_days' = 'extend_for_7_days',
  'extend_for_14_days' = 'extend_for_14_days',
  'extend_for_30_days' = 'extend_for_30_days',
  'extend_for_60_days' = 'extend_for_60_days',
  'valid_until' = 'valid_until',
  'activating_bid' = 'activating_bid',
  'bid_activated_successfully' = 'bid_activated_successfully',
  'activating_selected_bids' = 'activating_selected_bids',
  'bids_activated_successfully' = 'bids_activated_successfully',
  'pausing_bid' = 'pausing_bid',
  'bid_paused_successfully' = 'bid_paused_successfully',
  'extending_bids_validity' = 'extending_bids_validity',
  'bids_validity_extended_successfully' = 'bids_validity_extended_successfully',
  'extending_single_bid_validity' = 'extending_single_bid_validity',
  'single_bid_extended_successfully' = 'single_bid_extended_successfully',
  'deleting_bids' = 'deleting_bids',
  'bids_deleted_successfully' = 'bids_deleted_successfully',
  'deleting_single_bid' = 'deleting_single_bid',
  'single_bid_deleted_successfully' = 'single_bid_deleted_successfully',
  'bid_updated_successfully' = 'bid_updated_successfully',
  'order_details' = 'order_details',
  'progress_updates' = 'progress_updates',
  'please_upload_all_required_images' = 'please_upload_all_required_images',
  'images_uploaded_successfully' = 'images_uploaded_successfully',
  'error_uploading_images' = 'error_uploading_images',
  'upload_photos_of_the_bottle_you_sell' = 'upload_photos_of_the_bottle_you_sell',
  'every_product_will_be_auth' = 'every_product_will_be_auth',
  'requeriments_and_tips' = 'requeriments_and_tips',
  'examples' = 'examples',
  'payment_intent_auth_failure' = 'payment_intent_auth_failure',
  'not_loaded' = 'not_loaded',
  'portfolio_updated' = 'portfolio_updated',
  'purchase_price_must_be_greater_than_zero' = 'purchase_price_must_be_greater_than_zero',
  'your_collection' = 'your_collection',
  'edit_item_in_your_collection' = 'edit_item_in_your_collection',
  'are_you_sure_you_want_to_delete_this_product' = 'are_you_sure_you_want_to_delete_this_product',
  'about' = 'about',
  'go_to_the_bottle' = 'go_to_the_bottle',
  'by' = 'by',
  'featured_in' = 'featured_in',
  'unreaded' = 'unreaded',
  'unread' = 'unread',
  'askPriceDots' = 'askPriceDots',
  'bidPriceDots' = 'bidPriceDots',
  'currentPriceDots' = 'currentPriceDots',
  'item' = 'item',
  'see_all' = 'see_all',
  'there_are_no_unreaded_notifications' = 'there_are_no_unreaded_notifications',
  '24_hours' = '24_hours',
  '3_days' = '3_days',
  '7_days' = '7_days',
  '1_month' = '1_month',
  '1_year' = '1_year',
  'no_results' = 'no_results',
  'readed' = 'readed',
  'activating_ask' = 'activating_ask',
  'ask_activated_successfully' = 'ask_activated_successfully',
  'asks_activated_successfully' = 'asks_activated_successfully',
  'activating_asks' = 'activating_asks',
  'pausing_ask' = 'pausing_ask',
  'ask_paused_successfully' = 'ask_paused_successfully',
  'extending_validity_of_asks' = 'extending_validity_of_asks',
  'asks_paused_successfully' = 'asks_paused_successfully',
  'pausing_asks' = 'pausing_asks',
  'your_asks_validity_extended_successfully' = 'your_asks_validity_extended_successfully',
  'extending_ask_validity' = 'extending_ask_validity',
  'ask_validity_extended_successfully' = 'ask_validity_extended_successfully',
  'deleting_asks' = 'deleting_asks',
  'asks_deleted_successfully' = 'asks_deleted_successfully',
  'deleting_ask' = 'deleting_ask',
  'ask_deleted_successfully' = 'ask_deleted_successfully',
  'ask_updated_successfully' = 'ask_updated_successfully',
  'ask_details' = 'ask_details',
  'price_of_ask' = 'price_of_ask',
  'are_you_sure_you_want_to_delete_this_ask' = 'are_you_sure_you_want_to_delete_this_ask',
  'edit_ask' = 'edit_ask',
  'successfully_saved' = 'successfully_saved',
  'failed' = 'failed',
  'error' = 'error',
  'sale_details' = 'sale_details',
  'please_fill_all_fields' = 'please_fill_all_fields',
  'please_agree_with_terms_and_conditions' = 'please_agree_with_terms_and_conditions',
  'sending_contact_form' = 'sending_contact_form',
  'contact_form_sent_successfully' = 'contact_form_sent_successfully',
  'error_while_sending_contact_form' = 'error_while_sending_contact_form',
  'allCountries.australia' = 'allCountries.australia',
  'allCountries.austria' = 'allCountries.austria',
  'allCountries.belgium' = 'allCountries.belgium',
  'allCountries.brazil' = 'allCountries.brazil',
  'allCountries.bulgaria' = 'allCountries.bulgaria',
  'allCountries.canada' = 'allCountries.canada',
  'allCountries.croatia' = 'allCountries.croatia',
  'allCountries.cyprus' = 'allCountries.cyprus',
  'allCountries.czech_republic' = 'allCountries.czech_republic',
  'allCountries.denmark' = 'allCountries.denmark',
  'allCountries.estonia' = 'allCountries.estonia',
  'allCountries.finland' = 'allCountries.finland',
  'allCountries.france' = 'allCountries.france',
  'allCountries.germany' = 'allCountries.germany',
  'allCountries.gibraltar' = 'allCountries.gibraltar',
  'allCountries.greece' = 'allCountries.greece',
  'allCountries.hong_kong_sar_china' = 'allCountries.hong_kong_sar_china',
  'allCountries.hungary' = 'allCountries.hungary',
  'allCountries.india' = 'allCountries.india',
  'allCountries.indonesia' = 'allCountries.indonesia',
  'allCountries.ireland' = 'allCountries.ireland',
  'allCountries.italy' = 'allCountries.italy',
  'allCountries.japan' = 'allCountries.japan',
  'allCountries.latvia' = 'allCountries.latvia',
  'allCountries.liechtenstein' = 'allCountries.liechtenstein',
  'allCountries.lithuania' = 'allCountries.lithuania',
  'allCountries.luxembourg' = 'allCountries.luxembourg',
  'allCountries.malaysia' = 'allCountries.malaysia',
  'allCountries.malta' = 'allCountries.malta',
  'allCountries.mexico' = 'allCountries.mexico',
  'allCountries.netherlands' = 'allCountries.netherlands',
  'allCountries.new_zealand' = 'allCountries.new_zealand',
  'allCountries.norway' = 'allCountries.norway',
  'allCountries.poland' = 'allCountries.poland',
  'allCountries.portugal' = 'allCountries.portugal',
  'allCountries.romania' = 'allCountries.romania',
  'allCountries.singapore' = 'allCountries.singapore',
  'allCountries.slovakia' = 'allCountries.slovakia',
  'allCountries.slovenia' = 'allCountries.slovenia',
  'allCountries.spain' = 'allCountries.spain',
  'allCountries.sweden' = 'allCountries.sweden',
  'allCountries.switzerland' = 'allCountries.switzerland',
  'allCountries.thailand' = 'allCountries.thailand',
  'allCountries.united_arab_emirates' = 'allCountries.united_arab_emirates',
  'allCountries.united_kingdom' = 'allCountries.united_kingdom',
  'allCountries.united_states' = 'allCountries.united_states',
  'no_items_available_with_current_filters' = 'no_items_available_with_current_filters',
  'choose_your_price' = 'choose_your_price',
  'reset' = 'reset',
  'minimum' = 'minimum',
  'maximum' = 'maximum',
  'sort_by' = 'sort_by',
  'region' = 'region',
  'sub_category' = 'sub_category',
  'complete_profile_to_became_a_buyer' = 'complete_profile_to_became_a_buyer',
  'complete_profile_to_became_a_seller' = 'complete_profile_to_became_a_seller',
  'scotland' = 'scotland',
  'japan' = 'japan',
  'usa' = 'usa',
  'mexico' = 'mexico',
  'complete_your_account' = 'complete_your_account',
  'we_sent_email' = 'we_sent_email',
  'a_new_verification_link' = 'a_new_verification_link',
  'explore_spiritory' = 'explore_spiritory',
  'resend_confirmation_email' = 'resend_confirmation_email',
  'scotch_whisky' = 'scotch_whisky',
  'american_whisky' = 'american_whisky',
  'japanese_whisky' = 'japanese_whisky',
  'irish_whisky' = 'irish_whisky',
  'german_whisky' = 'german_whisky',
  'taiwanese_whisky' = 'taiwanese_whisky',
  'spiritory_whiskey_and_wine' = 'spiritory_whiskey_and_wine',
  'download_the_app' = 'download_the_app',
  'download' = 'download',
  'collections_curated_by' = 'collections_curated_by',
  'collection_subtitle' = 'collection_subtitle',
  'tags' = 'tags',
  'family' = 'family',
  'ocacion' = 'ocacion',
  'collection_by' = 'collection_by',
  'items' = 'items',
  'created' = 'created',
  'only_following_countries' = 'only_following_countries',
  'deleting_bottles' = 'deleting_bottles',
  'bottles_deleted_successfully' = 'bottles_deleted_successfully',
  'deleting_bottle' = 'deleting_bottle',
  'bottle_deleted_successfully' = 'bottle_deleted_successfully',
  'error_deleting_bottle' = 'error_deleting_bottle',
  'sending_bottle_suggestion' = 'sending_bottle_suggestion',
  'bottle_suggestion_sent_successfully' = 'bottle_suggestion_sent_successfully',
  'creating_your_bid' = 'creating_your_bid',
  'creating_your_order' = 'creating_your_order',
  'error_creating_your_bid' = 'error_creating_your_bid',
  'error_creating_your_order' = 'error_creating_your_order',
  'successfully_created_your_bid' = 'successfully_created_your_bid',
  'successfully_created_your_order' = 'successfully_created_your_order',
  'saved' = 'saved',
  'proccesing_your_ask' = 'proccesing_your_ask',
  'ask_created_successfully' = 'ask_created_successfully',
  'error_creating_your_ask' = 'error_creating_your_ask',
  'proccesing_your_sale' = 'proccesing_your_sale',
  'sale_created_successfully' = 'sale_created_successfully',
  'error_creating_your_sale' = 'error_creating_your_sale',
  'detail' = 'detail',
  'page_not_found' = 'page_not_found',
  'error_page_title' = 'error_page_title',
  'error_page_subtitle' = 'error_page_subtitle',
  'contact_support' = 'contact_support',
  'this_page_doesnt_exist_or_has_been_removed' = 'this_page_doesnt_exist_or_has_been_removed',
  'refresh_the_page' = 'refresh_the_page',
  'go_back' = 'go_back',
  'next' = 'next',
  'previous' = 'previous',
  'skus_title' = 'skus_title',
  'rum_meta_title' = 'rum_meta_title',
  'whisky_meta_title' = 'whisky_meta_title',
  'gin_meta_title' = 'gin_meta_title',
  'other_meta_title' = 'other_meta_title',
  'main_algolia_index_title' = 'main_algolia_index_title',
  'most_watched_desc_title' = 'most_watched_desc_title',
  'scotland_whisky_meta_title' = 'scotland_whisky_meta_title',
  'meta_scotland_whisky_title' = 'meta_scotland_whisky_title',
  'meta_usa_whisky_title' = 'meta_usa_whisky_title',
  'meta_japan_whisky_title' = 'meta_japan_whisky_title',
  'meta_ireland_whisky_title' = 'meta_ireland_whisky_title',
  'meta_germany_whisky_title' = 'meta_germany_whisky_title',
  'meta_taiwan_whisky_title' = 'meta_taiwan_whisky_title',
  'usa_whisky_meta_title' = 'usa_whisky_meta_title',
  'japan_whisky_meta_title' = 'japan_whisky_meta_title',
  'ireland_whisky_meta_title' = 'ireland_whisky_meta_title',
  'germany_whisky_meta_title' = 'germany_whisky_meta_title',
  'taiwan_whisky_meta_title' = 'taiwan_whisky_meta_title',
  'buy_and_sell_whisky_name' = 'buy_and_sell_whisky_name',
  'sku_description' = 'sku_description',
  'how_it_works_title' = 'how_it_works_title',
  'how_it_works_description' = 'how_it_works_description',
  'buyer_guide_title' = 'buyer_guide_title',
  'buyer_guide_description' = 'buyer_guide_description',
  'authenticating_title' = 'authenticating_title',
  'authenticating_description' = 'authenticating_description',
  'portfolio_title' = 'portfolio_title',
  'portfolio_description' = 'portfolio_description',
  'condition_guide_title' = 'condition_guide_title',
  'condition_guide_description' = 'condition_guide_description',
  'blog_title' = 'blog_title',
  'blog_description' = 'blog_description',
  'blog_keywords' = 'blog_keywords',
  'blog_subject' = 'blog_subject',
  'blog_category' = 'blog_category',
  'spiritory_blog' = 'spiritory_blog',
  'seller_guide_title' = 'seller_guide_title',
  'seller_guide_description' = 'seller_guide_description',
  'shipping_guide_title' = 'shipping_guide_title',
  'shipping_guide_description' = 'shipping_guide_description',
  'collection_title' = 'collection_title',
  'collection_description' = 'collection_description',
  'a_z' = 'a_z',
  'newest' = 'newest',
  'language_changed_successfully' = 'language_changed_successfully',
  'basic_business_information' = 'basic_business_information',
  'step1_head_question' = 'step1_head_question',
  'step1_single_company_question1' = 'step1_single_company_question1',
  'step1_single_company_question2' = 'step1_single_company_question2',
  'capital_company' = 'capital_company',
  'commercial_partnership' = 'commercial_partnership',
  'businessType' = 'businessType',
  'personal_data' = 'personal_data',
  'business_address' = 'business_address',
  'tax_information' = 'tax_information',
  'business_name' = 'business_name',
  'business_country' = 'business_country',
  'business_city' = 'business_city',
  'business_zip_code' = 'business_zip_code',
  'business_tax_id' = 'business_tax_id',
  'beneficial_owner' = 'beneficial_owner',
  'shareholder' = 'shareholder',
  'commercial_business_number' = 'commercial_business_number',
  'professional_seller_information_saved' = 'professional_seller_information_saved',
  'submitting' = 'submitting',
  'submitting_your_information' = 'submitting_your_information',
  'submitting_your_professional_information' = 'submitting_your_professional_information',
  'note' = 'note',
  'verification_of_professional_seller_status' = 'verification_of_professional_seller_status',
  'prof_only_allowed' = 'prof_only_allowed',
  'from_where_do_you_ship_your_products' = 'from_where_do_you_ship_your_products',
  'origin_address' = 'origin_address',
  'business_country_not_allowed' = 'business_country_not_allowed',
  'personal_country_not_allowed' = 'personal_country_not_allowed',
  'shipping_country_not_allowed' = 'shipping_country_not_allowed',
  'show_shipping_information' = 'show_shipping_information',
  'shipping_failed' = 'shipping_failed',
  'shipping_failed_sub' = 'shipping_failed_sub',
  'prof_seller' = 'prof_seller',
  'this_ask_is_from_a_professional_seller' = 'this_ask_is_from_a_professional_seller',
  'this_product_is_sold_by_a_professional_seller' = 'this_product_is_sold_by_a_professional_seller',
  'error_creating_your_order_contact_customer_support' = 'error_creating_your_order_contact_customer_support',
  'business_number_info' = 'business_number_info',
  'saving_shipping_address' = 'saving_shipping_address',
  'shipping_address_saved_successfully' = 'shipping_address_saved_successfully',
  'error_saving_shipping_address' = 'error_saving_shipping_address',
  'search_for_a_country' = 'search_for_a_country',
  'phone_number_is_required' = 'phone_number_is_required',
  'invalid_phone_number' = 'invalid_phone_number',
  'submitting_phone_number' = 'submitting_phone_number',
  'phone_number_submitted_successfully' = 'phone_number_submitted_successfully',
  'error_submitting_phone_number' = 'error_submitting_phone_number',
  'add_your_phone_number' = 'add_your_phone_number',
  'add_your_phone_number_description' = 'add_your_phone_number_description',
  'priceDots' = 'priceDots',
  'andUpTo' = 'andUpTo',
  'we_are_sorry_professional_seller_not_allowed' = 'we_are_sorry_professional_seller_not_allowed',
  'go_back_to_main_menu' = 'go_back_to_main_menu',
  'go_back_to_browse_menu' = 'go_back_to_browse_menu',
  'go_back_to_dashboard_menu' = 'go_back_to_dashboard_menu',
  'no_products_found' = 'no_products_found',
  'just_a_moment' = 'just_a_moment',
  'languageModalBody' = 'languageModalBody',
  'languageModalTitle' = 'languageModalTitle',
  'name_must_be_at_least_two_characters_long' = 'name_must_be_at_least_two_characters_long',
  'spaces_not_allowed' = 'spaces_not_allowed',
  'only_letters_allowed' = 'only_letters_allowed',
  'you_need_to_be_a_buyer_first' = 'you_need_to_be_a_buyer_first',
  'business_information' = 'business_information',
  'loading_data_subtitle' = 'loading_data_subtitle',
  'select_language' = 'select_language',
  'coupons' = 'coupons',
  'coupon.coupon' = 'coupon.coupon',
  'coupon.already_used' = 'coupon.already_used',
  'coupon.already_applied_to_order' = 'coupon.already_applied_to_order',
  'coupon.already_used_by_user' = 'coupon.already_used_by_user',
  'coupon.only_valid_for_new_users' = 'coupon.only_valid_for_new_users',
  'coupon.coupon_not_found' = 'coupon.coupon_not_found',
  'coupon.coupon_max_usage' = 'coupon.coupon_max_usage',
  'coupon.coupon_applied' = 'coupon.coupon_applied',
  'coupon.failed_to_apply_coupon' = 'coupon.failed_to_apply_coupon',
  'coupon.removing_coupon' = 'coupon.removing_coupon',
  'coupon.failed_to_remove_coupon' = 'coupon.failed_to_remove_coupon',
  'coupon.coupon_removed' = 'coupon.coupon_removed',
  'coupon.applying_coupon' = 'coupon.applying_coupon',
  'coupon.remove_coupon' = 'coupon.remove_coupon',
  'coupon.are_you_sure_you_want_to_remove_this_coupon' = 'coupon.are_you_sure_you_want_to_remove_this_coupon',
  'explore_collections' = 'explore_collections',
  'referrals.success.referrals_influencer' = 'referrals.success.referrals_influencer',
  'referrals.success.welcome' = 'referrals.success.welcome',
  'referrals.success.you_have_been_referred_influencer' = 'referrals.success.you_have_been_referred_influencer',
  'referrals.success.they_re_inviting_you_to_join_influencer' = 'referrals.success.they_re_inviting_you_to_join_influencer',
  'referrals.success.sign_up_now_influencer' = 'referrals.success.sign_up_now_influencer',
  'referrals.success.to_unlock_your_special_gift_influencer' = 'referrals.success.to_unlock_your_special_gift_influencer',
  'referrals.success.click_sign_up_below_influencer' = 'referrals.success.click_sign_up_below_influencer',
  'referrals.success.to_get_started_influencer' = 'referrals.success.to_get_started_influencer',
  'referrals.success.dont_wait_too_long_influencer' = 'referrals.success.dont_wait_too_long_influencer',
  'referrals.error.invalid_referral_influencer' = 'referrals.error.invalid_referral_influencer',
  'referrals.error.oops_influencer' = 'referrals.error.oops_influencer',
  'referrals.error.link_invalid_influencer' = 'referrals.error.link_invalid_influencer',
  'referrals.error.please_double_check_influencer' = 'referrals.error.please_double_check_influencer',
  'referrals.error.try_again_influencer' = 'referrals.error.try_again_influencer',
  'referrals.error.get_fresh_link_influencer' = 'referrals.error.get_fresh_link_influencer',
  'referrals.error.need_help_influencer' = 'referrals.error.need_help_influencer',
  'referrals.ok' = 'referrals.ok',
  'referrals.sign_up' = 'referrals.sign_up',
  'referrals.friends.friends' = 'referrals.friends.friends',
  'referrals.friends.referrals' = 'referrals.friends.referrals',
  'referrals.friends.you_dont_have_any_referral_link_yet' = 'referrals.friends.you_dont_have_any_referral_link_yet',
  'referrals.friends.start_referring_your_friends_and_earn_rewards' = 'referrals.friends.start_referring_your_friends_and_earn_rewards',
  'referrals.friends.start_referring' = 'referrals.friends.start_referring',
  'referrals.friends.referral_program' = 'referrals.friends.referral_program',
  'referrals.friends.your_referrals' = 'referrals.friends.your_referrals',
  'referrals.friends.start_referring_subtitle' = 'referrals.friends.start_referring_subtitle',
  'referrals.friends.total_earned' = 'referrals.friends.total_earned',
  'referrals.friends.what_you_have_earned_so_far_for_referring_your_friends' = 'referrals.friends.what_you_have_earned_so_far_for_referring_your_friends',
  'referrals.friends.friends_referred' = 'referrals.friends.friends_referred',
  'referrals.friends.how_many_friends_you_have_referred_so_far' = 'referrals.friends.how_many_friends_you_have_referred_so_far',
  'referrals.friends.how_it_works.how_it_works' = 'referrals.friends.how_it_works.how_it_works',
  'referrals.friends.how_it_works.steps.step_1_title' = 'referrals.friends.how_it_works.steps.step_1_title',
  'referrals.friends.how_it_works.steps.step_1_description' = 'referrals.friends.how_it_works.steps.step_1_description',
  'referrals.friends.how_it_works.steps.step_2_title' = 'referrals.friends.how_it_works.steps.step_2_title',
  'referrals.friends.how_it_works.steps.step_2_description' = 'referrals.friends.how_it_works.steps.step_2_description',
  'referrals.friends.how_it_works.steps.step_3_title' = 'referrals.friends.how_it_works.steps.step_3_title',
  'referrals.friends.how_it_works.steps.step_3_description' = 'referrals.friends.how_it_works.steps.step_3_description',
  'referrals.friends.how_it_works.steps.step_4_title' = 'referrals.friends.how_it_works.steps.step_4_title',
  'referrals.friends.how_it_works.steps.step_4_description' = 'referrals.friends.how_it_works.steps.step_4_description',
  'referrals.friends.how_it_works.steps.step_5_title' = 'referrals.friends.how_it_works.steps.step_5_title',
  'referrals.friends.how_it_works.steps.step_5_description' = 'referrals.friends.how_it_works.steps.step_5_description',
  'referrals.friends.no_referrals_found' = 'referrals.friends.no_referrals_found',
  'referrals.friends.no_rewards_found' = 'referrals.friends.no_rewards_found',
  'referrals.friends.earn_exclusive_rewards_with_my_link' = 'referrals.friends.earn_exclusive_rewards_with_my_link',
  'referrals.friends.reward' = 'referrals.friends.reward',
  'referrals.friends.expires_at' = 'referrals.friends.expires_at',
  'referrals.friends.max_uses' = 'referrals.friends.max_uses',
  'referrals.friends.code' = 'referrals.friends.code',
  'referrals.friends.your_rewards' = 'referrals.friends.your_rewards',
  'referrals.friends.success.referrals_friend' = 'referrals.friends.success.referrals_friend',
  'referrals.friends.success.welcome' = 'referrals.friends.success.welcome',
  'referrals.friends.success.you_have_been_referred_friend' = 'referrals.friends.success.you_have_been_referred_friend',
  'referrals.friends.success.they_re_inviting_you_to_join_friend' = 'referrals.friends.success.they_re_inviting_you_to_join_friend',
  'referrals.friends.success.sign_up_now_friend' = 'referrals.friends.success.sign_up_now_friend',
  'referrals.friends.success.to_unlock_your_special_gift_friend' = 'referrals.friends.success.to_unlock_your_special_gift_friend',
  'referrals.friends.success.click_sign_up_below_friend' = 'referrals.friends.success.click_sign_up_below_friend',
  'referrals.friends.success.to_get_started_friend' = 'referrals.friends.success.to_get_started_friend',
  'referrals.friends.success.dont_wait_too_long_friend' = 'referrals.friends.success.dont_wait_too_long_friend',
  'referrals.friends.error.invalid_referral_friend' = 'referrals.friends.error.invalid_referral_friend',
  'referrals.friends.error.oops_friend' = 'referrals.friends.error.oops_friend',
  'referrals.friends.error.link_invalid_friend' = 'referrals.friends.error.link_invalid_friend',
  'referrals.friends.error.please_double_check_friend' = 'referrals.friends.error.please_double_check_friend',
  'referrals.friends.error.try_again_friend' = 'referrals.friends.error.try_again_friend',
  'referrals.friends.error.get_fresh_link_friend' = 'referrals.friends.error.get_fresh_link_friend',
  'referrals.friends.error.need_help_friend' = 'referrals.friends.error.need_help_friend',
  'referrals.creating_referral_code' = 'referrals.creating_referral_code',
  'referrals.referral_code_created_successfully' = 'referrals.referral_code_created_successfully',
  'referrals.error_creating_referral_code' = 'referrals.error_creating_referral_code',
  'festival.welcome' = 'festival.welcome',
  'festival.we_hope' = 'festival.we_hope',
  'festival.exclusive_reward' = 'festival.exclusive_reward',
  'festival.enter_the_discount_code' = 'festival.enter_the_discount_code',
  'festival.dont_wait' = 'festival.dont_wait',
  'festival.got_it' = 'festival.got_it',
  'festival_v2.welcome_message' = 'festival_v2.welcome_message',
  'festival_v2.event_feedback' = 'festival_v2.event_feedback',
  'festival_v2.excitement_invite' = 'festival_v2.excitement_invite',
  'festival_v2.exclusive_reward' = 'festival_v2.exclusive_reward',
  'festival_v2.discount_instructions' = 'festival_v2.discount_instructions',
  'festival_v2.urgency_notice' = 'festival_v2.urgency_notice',
  'your_account_is_blocked_please_contact_support' = 'your_account_is_blocked_please_contact_support',
  'alert' = 'alert',
  'spiritorySliderBanner.now_or_never.title' = 'spiritorySliderBanner.now_or_never.title',
  'spiritorySliderBanner.now_or_never.subtitle' = 'spiritorySliderBanner.now_or_never.subtitle',
  'spiritorySliderBanner.last_chance.title' = 'spiritorySliderBanner.last_chance.title',
  'spiritorySliderBanner.last_chance.subtitle' = 'spiritorySliderBanner.last_chance.subtitle',
  'spiritorySliderBanner.act_fast.title' = 'spiritorySliderBanner.act_fast.title',
  'spiritorySliderBanner.act_fast.subtitle' = 'spiritorySliderBanner.act_fast.subtitle',
  'spiritorySliderBanner.big_deal.title' = 'spiritorySliderBanner.big_deal.title',
  'spiritorySliderBanner.big_deal.subtitle' = 'spiritorySliderBanner.big_deal.subtitle',
  'spiritorySliderBanner.unique_oportunity.title' = 'spiritorySliderBanner.unique_oportunity.title',
  'spiritorySliderBanner.unique_oportunity.subtitle' = 'spiritorySliderBanner.unique_oportunity.subtitle',
  'hours' = 'hours',
  'minutes' = 'minutes',
  'seconds' = 'seconds',
  'days' = 'days',
  'download_shipping_label' = 'download_shipping_label',
  'joined' = 'joined',
  'trackings' = 'trackings',
  'resetting_password' = 'resetting_password',
  'resetting_password_subtitle' = 'resetting_password_subtitle',
  'creating_account' = 'creating_account',
  'please_wait_while_we_create_your_account' = 'please_wait_while_we_create_your_account',
  'changing_language' = 'changing_language',
  'verifying_email' = 'verifying_email',
  'loading_email_verification' = 'loading_email_verification',
  'please_wait_while_we_load_email_verification' = 'please_wait_while_we_load_email_verification',
  'please_wait_while_we_verify_your_email' = 'please_wait_while_we_verify_your_email',
  'referral_code_not_found' = 'referral_code_not_found',
  'referral_code_redeemed' = 'referral_code_redeemed',
  'user_already_referred' = 'user_already_referred',
  'referrer_not_found' = 'referrer_not_found',
  'referee_not_found' = 'referee_not_found',
  'user_account_too_old' = 'user_account_too_old',
  'referrer_referee_same_person' = 'referrer_referee_same_person',
  'invalid_captcha_try_again_or_refresh' = 'invalid_captcha_try_again_or_refresh',
  'captcha_is_required' = 'captcha_is_required',
  'sending_email_request' = 'sending_email_request',
  'email_sent_successfully' = 'email_sent_successfully',
  'a_user_with_this_email_was_not_found' = 'a_user_with_this_email_was_not_found',
  'email_is_already_verified' = 'email_is_already_verified',
  'invalid_captcha_please_try_again' = 'invalid_captcha_please_try_again',
  'faqs.faq1_q' = 'faqs.faq1_q',
  'faqs.faq1_a' = 'faqs.faq1_a',
  'faqs.faq2_q' = 'faqs.faq2_q',
  'faqs.faq2_a' = 'faqs.faq2_a',
  'faqs.faq3_q' = 'faqs.faq3_q',
  'faqs.faq3_a' = 'faqs.faq3_a',
  'faqs.faq4_q' = 'faqs.faq4_q',
  'faqs.faq4_a' = 'faqs.faq4_a',
  'faqs.faq5_q' = 'faqs.faq5_q',
  'faqs.faq5_a' = 'faqs.faq5_a',
  'faqs.faq6_q' = 'faqs.faq6_q',
  'faqs.faq6_a' = 'faqs.faq6_a',
  'faqs.faq7_q' = 'faqs.faq7_q',
  'faqs.faq7_a' = 'faqs.faq7_a',
  'faqs.faq8_a' = 'faqs.faq8_a',
  'faqs.faq8_q' = 'faqs.faq8_q',
  'faqs.faq9_a' = 'faqs.faq9_a',
  'faqs.faq9_q' = 'faqs.faq9_q',
  'faqs.faq10_q' = 'faqs.faq10_q',
  'faqs.faq10_a' = 'faqs.faq10_a',
  'no_data_card_heading_authors' = 'no_data_card_heading_authors',
  'no_data_card_message_authors' = 'no_data_card_message_authors',
  'no_data_card_heading_blog' = 'no_data_card_heading_blog',
  'no_data_card_message_blog' = 'no_data_card_message_blog',
  'no_data_card_heading_wishlist' = 'no_data_card_heading_wishlist',
  'no_data_card_message_wishlist' = 'no_data_card_message_wishlist',
  'no_data_card_heading_notifications' = 'no_data_card_heading_notifications',
  'no_data_card_message_notifications' = 'no_data_card_message_notifications',
  'successfully_updated_your_bid' = 'successfully_updated_your_bid',
  'error_updating_your_bid' = 'error_updating_your_bid',
  'updating_your_bid' = 'updating_your_bid',
  'error_updating_your_ask' = 'error_updating_your_ask',
  'updating_your_ask' = 'updating_your_ask',
  'sku_description_new1' = 'sku_description_new1',
  'sku_description_new2' = 'sku_description_new2',
  'sku_title_new2' = 'sku_title_new2',
  'sku_title_new1' = 'sku_title_new1',
  'enter_phone_number' = 'enter_phone_number',
  'email_sent_for_password_change' = 'email_sent_for_password_change',
  'sending_email_for_password_change' = 'sending_email_for_password_change',
  'error_sending_email_for_password_change' = 'error_sending_email_for_password_change',
  'search_by_name' = 'search_by_name',
  'search_by_barcode' = 'search_by_barcode',
  'by_name' = 'by_name',
  'by_barcode' = 'by_barcode',
  'marketing.win_bottle_sign_up.win_this_bottle' = 'marketing.win_bottle_sign_up.win_this_bottle',
  'marketing.win_bottle_sign_up.sign_up_and_participate_in_a_bottle_giveway_each_month' = 'marketing.win_bottle_sign_up.sign_up_and_participate_in_a_bottle_giveway_each_month',
  'see_more' = 'see_more',
  'see_less' = 'see_less',
  'sales_chart.periods.1W' = 'sales_chart.periods.1W',
  'sales_chart.periods.1M' = 'sales_chart.periods.1M',
  'sales_chart.periods.6M' = 'sales_chart.periods.6M',
  'sales_chart.periods.1Y' = 'sales_chart.periods.1Y',
  'sales_chart.periods.MAX' = 'sales_chart.periods.MAX',
  'the_result_in_variablePeriod' = 'the_result_in_variablePeriod',
  'loadingMessages.msg_1.title' = 'loadingMessages.msg_1.title',
  'loadingMessages.msg_1.subtitle' = 'loadingMessages.msg_1.subtitle',
  'loadingMessages.msg_2.title' = 'loadingMessages.msg_2.title',
  'loadingMessages.msg_2.subtitle' = 'loadingMessages.msg_2.subtitle',
  'loadingMessages.msg_3.title' = 'loadingMessages.msg_3.title',
  'loadingMessages.msg_3.subtitle' = 'loadingMessages.msg_3.subtitle',
  'loadingMessages.msg_4.title' = 'loadingMessages.msg_4.title',
  'loadingMessages.msg_4.subtitle' = 'loadingMessages.msg_4.subtitle',
  'loadingMessages.msg_5.title' = 'loadingMessages.msg_5.title',
  'loadingMessages.msg_5.subtitle' = 'loadingMessages.msg_5.subtitle',
  'no_data_available_for_this_period' = 'no_data_available_for_this_period',
  'most_sold' = 'most_sold',
  'activity_type' = 'activity_type',
  'last_activities' = 'last_activities',
  'adding_bottle_to_portfolio' = 'adding_bottle_to_portfolio',
  'successful_bottle_addition' = 'successful_bottle_addition',
  'error_adding_bottle' = 'error_adding_bottle',
  'please_select_a_bottle' = 'please_select_a_bottle',
  'search_for_a_bottle' = 'search_for_a_bottle',
  'next_step' = 'next_step',
  'previous_step' = 'previous_step',
  'no_price' = 'no_price',
  'views' = 'views',
  'date_of_order' = 'date_of_order',
  'sign_in' = 'sign_in',
  'sign_up' = 'sign_up',
  'languages.en' = 'languages.en',
  'languages.de' = 'languages.de',
  'languages.es' = 'languages.es',
  'languages.fr' = 'languages.fr',
  'languages.it' = 'languages.it',
  'are_you_sure_you_want_to_confirm_that_you_have_received_the_bottle' = 'are_you_sure_you_want_to_confirm_that_you_have_received_the_bottle',
  'confirming_order_as_received' = 'confirming_order_as_received',
  'order_confirmed_as_received' = 'order_confirmed_as_received',
  'error_confirming_order_as_received' = 'error_confirming_order_as_received',
  'captcha_disclaimer_intro' = 'captcha_disclaimer_intro',
  'captcha_disclaimer_privacy_policy' = 'captcha_disclaimer_privacy_policy',
  'captcha_disclaimer_conjunction' = 'captcha_disclaimer_conjunction',
  'captcha_disclaimer_terms_of_service' = 'captcha_disclaimer_terms_of_service',
  'captcha_disclaimer_outro' = 'captcha_disclaimer_outro',
  'please_complete_onboarding_process_headline' = 'please_complete_onboarding_process_headline',
  'please_complete_onboarding_process_subline' = 'please_complete_onboarding_process_subline',
  'showing_fromVariable_to_toVariable_of_ofVariable_results' = 'showing_fromVariable_to_toVariable_of_ofVariable_results',
  'first_page' = 'first_page',
  'previous_page' = 'previous_page',
  'next_page' = 'next_page',
  'last_page' = 'last_page',
  'trending' = 'trending',
  'bottle_of_the_day' = 'bottle_of_the_day',
  'bottle_of_the_day_description_fallback' = 'bottle_of_the_day_description_fallback',
  'view_the_bottle' = 'view_the_bottle',
  'market_value' = 'market_value',
  'why_buy_on_spiritory' = 'why_buy_on_spiritory',
  'secure_payments_through_our_trusted_escrow_system' = 'secure_payments_through_our_trusted_escrow_system',
  'expert_verified_bottles_for_guaranteed_authenticity' = 'expert_verified_bottles_for_guaranteed_authenticity',
  'whisky_friendly_storage_conditions' = 'whisky_friendly_storage_conditions',
  'only_verified_sellers_meet_our_strict_quality_standards' = 'only_verified_sellers_meet_our_strict_quality_standards',
  'expert_support_whenever_you_need_assistance' = 'expert_support_whenever_you_need_assistance',
  'insured_shipping_to_protect_your_investment' = 'insured_shipping_to_protect_your_investment',
  'buy_sell_and_discover_your_favorite_bottles_anywhere_anytime' = 'buy_sell_and_discover_your_favorite_bottles_anywhere_anytime',
  'image' = 'image',
  'updated_at' = 'updated_at',
  'no_results_found' = 'no_results_found',
  'no_results_description_search_term' = 'no_results_description_search_term',
  'browse_all_spirits' = 'browse_all_spirits',
  'spiritory_magazine' = 'spiritory_magazine',
  'matched' = 'matched',
  'no_seller_has_left_an_ask_yet_you_can_determine_your_price_at_which_you_are_willing_to_buy_this_item' = 'no_seller_has_left_an_ask_yet_you_can_determine_your_price_at_which_you_are_willing_to_buy_this_item',
  'please_specify_the_price_at_which_you_would_like_to_buy' = 'please_specify_the_price_at_which_you_would_like_to_buy',
  'release_calendar' = 'release_calendar',
  'most_popular_around_you' = 'most_popular_around_you',
  'future_releases' = 'future_releases',
  'alphabetical' = 'alphabetical',
  'discover_spiritory' = 'discover_spiritory',
  'canadian_whisky' = 'canadian_whisky',
  'indian_whisky' = 'indian_whisky',
  'top_today' = 'top_today',
}

export { CommonEnum };
